import { ReleaseOfferRequestForAdminState } from './releaseOfferRequestForAdmin.types'

export const releaseOfferRequestForAdminInitialState: ReleaseOfferRequestForAdminState = {
  data: null,
  loading: false,
  error: null,
  success: false
}
